import AvailableUnitsLabel from '../../../../../pages/vip/features/available-units-label/available-units-label';

export default AvailableUnitsLabel;
